import { StorefrontData, StorefrontFile } from '../../models/StorefrontData'

export const FETCH_STOREFRONT_DONE = 'storefront//FETCH_STOREFRONT_DONE'
export const FETCH_STOREFRONT_STORE_ID = 'storefront//FETCH_STOREFRONT_STORE_ID'
export const FETCH_STOREFRONT_FILES = 'storefront//FETCH_STOREFRONT_FILES'
export const FETCH_STOREFRONT_TOKEN = 'storefront//FETCH_STOREFRONT_TOKEN'

interface DoneAction {
  type: typeof FETCH_STOREFRONT_DONE
  payload: { data: StorefrontData }
}

interface StoreIdAction {
  type: typeof FETCH_STOREFRONT_STORE_ID
  payload: { id: string }
}

interface FilesAction {
  type: typeof FETCH_STOREFRONT_FILES
  payload: { files: StorefrontFile[] }
}

interface TokenAction {
  type: typeof FETCH_STOREFRONT_TOKEN
  payload: { token: string }
}

export type StoreFrontActionTypes = DoneAction | StoreIdAction | FilesAction | TokenAction
